import "@webcomponents/custom-elements";
import * as BancoEstadoBar from "Components/bancoe-bar/bancoe-bar";
import * as NewSearchbox from "Components/searchbox/new-searchbox";
import * as SmartTimer from "Components/smart-timer/smart-timer";
import * as PcraLoginInfoModal from "Components/pcra-login-info-modal/peru-compra-login-info-modal";
import * as ChileCompraLoginInfoModal from "Components/chile-compra-login-info-modal/chile-compra-login-info-modal";
import * as Cug3LoginHandler from "Components/login-handlers/cug3-login-handler";
import * as AALoginHandler from "Components/login-handlers/aa-login-handler";
import * as RedemptionNoPromoCodeModal from "Components/redemption-no-promo-code-modal/redemption-no-promo-code-modal";
import * as AmericanAirlinesTokenModal from "Components/american-airlines-token-modal/american-airlines-token-modal";
import * as Header from "Components/main-menu/header";
import * as Accordion from "Components/accordion";
import * as Tabs from "Components/tabs";
import * as ChangePassengerNumberButton from "Components/searchbox/searchTab/flights/passenger-selector/change-passenger-number-button";
import * as Input from "Components/input";
import * as Dropdown from "Components/searchbox/searchTab/flights/dropdown";
import * as AdminLogin from "Components/admin/admin-login";
import * as AdminPage from "Components/admin/admin-page";
import * as AdminCheckbox from "Components/admin/admin-checkbox";
import * as AdminCheckboxInput from "Components/admin/admin-checkbox-input";
import { component } from "./haunted-component";

export function initCustomElements() {
	customElements.define(
		BancoEstadoBar.name,
		component<HTMLElement & BancoEstadoBar.Props>(BancoEstadoBar.Component, {
			useShadowDOM: BancoEstadoBar.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		AdminCheckbox.name,
		component<HTMLElement & AdminCheckbox.Props>(AdminCheckbox.Component, {
			useShadowDOM: false,
			observedAttributes: [],
		})
	);

	customElements.define(
		AdminCheckboxInput.name,
		component<HTMLElement & AdminCheckboxInput.Props>(AdminCheckboxInput.Component, {
			useShadowDOM: false,
			observedAttributes: [],
		})
	);

	customElements.define(
		AdminPage.name,
		component<HTMLElement & AdminPage.Attributes & AdminPage.Props>(AdminPage.Component, {
			useShadowDOM: false,
			observedAttributes: AdminPage.observedAttributes,
		})
	);

	customElements.define(
		AdminLogin.name,
		component<HTMLElement & AdminLogin.Attributes & AdminLogin.Props>(AdminLogin.Component, {
			useShadowDOM: false,
			observedAttributes: AdminLogin.observedAttributes,
		})
	);

	customElements.define(
		NewSearchbox.name,
		component<HTMLElement & NewSearchbox.Attributes & NewSearchbox.Props>(NewSearchbox.Component, {
			useShadowDOM: NewSearchbox.useShadowDOM,
			observedAttributes: NewSearchbox.observedAttributes,
		})
	);

	customElements.define(
		SmartTimer.name,
		component<HTMLElement & SmartTimer.Props & SmartTimer.Attributes>(SmartTimer.Component, {
			useShadowDOM: SmartTimer.useShadowDOM,
			observedAttributes: SmartTimer.observedAttributes,
		})
	);

	customElements.define(
		PcraLoginInfoModal.name,
		component<HTMLElement>(PcraLoginInfoModal.Component, {
			useShadowDOM: PcraLoginInfoModal.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		ChileCompraLoginInfoModal.name,
		component<HTMLElement>(ChileCompraLoginInfoModal.Component, {
			useShadowDOM: ChileCompraLoginInfoModal.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		Cug3LoginHandler.name,
		component<HTMLElement>(Cug3LoginHandler.Component, {
			useShadowDOM: Cug3LoginHandler.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		AALoginHandler.name,
		component<HTMLElement>(AALoginHandler.Component, {
			useShadowDOM: AALoginHandler.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		RedemptionNoPromoCodeModal.name,
		component<HTMLElement & RedemptionNoPromoCodeModal.Attributes & RedemptionNoPromoCodeModal.Props>(
			RedemptionNoPromoCodeModal.Component,
			{
				useShadowDOM: RedemptionNoPromoCodeModal.useShadowDOM,
				observedAttributes: RedemptionNoPromoCodeModal.observedAttributes,
			}
		)
	);

	customElements.define(
		AmericanAirlinesTokenModal.name,
		component<HTMLElement>(AmericanAirlinesTokenModal.Component, {
			useShadowDOM: AmericanAirlinesTokenModal.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		Header.name,
		component<HTMLElement & Header.Props & Header.Attributes>(Header.Component, {
			useShadowDOM: Header.useShadowDOM,
			observedAttributes: Header.observedAttributes,
		})
	);

	customElements.define(
		Accordion.name,
		component<HTMLElement & Accordion.Props>(Accordion.Component, {
			useShadowDOM: Accordion.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		Tabs.name,
		component<HTMLElement & { dto: Tabs.TabProps<any> }>(Tabs.Component, {
			useShadowDOM: Tabs.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		Dropdown.name,
		component<HTMLElement & Dropdown.Props>(Dropdown.Component, {
			useShadowDOM: Dropdown.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		ChangePassengerNumberButton.name,
		component<HTMLElement & ChangePassengerNumberButton.Props>(ChangePassengerNumberButton.Component, {
			useShadowDOM: ChangePassengerNumberButton.useShadowDOM,
			observedAttributes: [],
		})
	);

	customElements.define(
		Input.name,
		component<HTMLElement & Input.Props>(Input.Component, {
			useShadowDOM: Input.useShadowDOM,
			observedAttributes: [],
		})
	);
}
